export const TOKEN_STORAGE_KEYS = {
  POST_LOGOUT_REDIRECT: 'postLogoutRedirect',
  POST_EDLINK_REDIRECT: 'postEdLinkRedirect'
};
